import { AffidavitReconciliationSettings } from '../types/organization';

type WetSignatureSettings = Pick<
  AffidavitReconciliationSettings,
  'notarizationVendor'
>;

/**
 * Single source of truth for "will this notice get a wet-signature affidavit".
 *
 * Placement and invoice pricing must answer this the same way: placement tells the filer
 * the publisher covers the first copy, and pricing only honours that promise when this
 * returns true. Both sides read it from here so the two cannot drift apart.
 *
 * Pass the settings resolved through getAffidavitSettingsForNoticeData, not a single
 * layer: a customer or notice type setting 'notarize' opts out of a publisher mandate.
 */
export function requiresWetSignature(
  settings: Partial<WetSignatureSettings> | null | undefined
): boolean {
  return settings?.notarizationVendor === 'manual';
}
